import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import styled from 'styled-components';
import { Sidebar } from '@/components/Sidebar';
import { useAuth } from '@/providers/AuthProvider';

const LoadingScreen = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  color: #6b7280;
  font-size: 14px;
`;

const AppShell = styled.div`
  display: flex;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  background: #f9fafb;
  min-width: 0;
`;

function RootLayout() {
  const routerState = useRouterState();
  const { isLoading } = useAuth();
  const isEditorPage = routerState.location.pathname.includes('/edit');

  if (isLoading) {
    return <LoadingScreen>Loading...</LoadingScreen>;
  }

  // Editor pages get no shell — the editor has its own full-screen chrome
  if (isEditorPage) {
    return <Outlet />;
  }

  return (
    <AppShell>
      <Sidebar />
      <MainContent>
        <Outlet />
      </MainContent>
    </AppShell>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
